import React, { useEffect, useState } from "react";
import axiosClient from "../../../axios";
import { Link } from "react-router-dom";

const AffiliateApplications = () => {
  const [affiliates, setAffiliates] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchAffiliates();
  }, []);

  const fetchAffiliates = async () => {
    try {
      const response = await axiosClient.get(
        "/api/affiliates/list?status=active",
      );
      // Laravel can return { data: [...] } or just [...]
      setAffiliates(response.data?.data || response.data || []);
    } catch (err) {
      setError(err.response?.data?.message || "Failed to load affiliates");
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  if (loading) return <div className="p-4">Loading...</div>;
  if (error) return <div className="alert alert-danger">{error}</div>;

  return (
    <div className="container">
      <h2 className="mb-4">Applications</h2>

      {/* Show empty state if no affiliates */}
      {!affiliates || affiliates.length === 0 ? (
        <div className="alert alert-info">
          No pending affiliate applications found
        </div>
      ) : (
        <div className="table-responsive">
          <table className="table table-bordered align-middle">
            <thead className="table-light">
              <tr>
                <th>#</th>
                <th>User</th>
                <th>Email</th>
                <th>Referral Code</th>
                <th>Bank</th>
              </tr>
            </thead>
            <tbody>
              {affiliates.map((aff, idx) => (
                <tr key={aff.id}>
                  <td>{idx + 1}</td>
                  <td>
                    <Link to={`/xl-admin/affiliates/${aff.id}`}>
                      {aff.user?.name || "—"}
                    </Link>
                  </td>
                  <td>{aff.user?.email || "—"}</td>
                  <td>{aff.referral_code || "—"}</td>
                  <td>
                    <div>
                      <strong>{aff.bank_name || "—"}</strong>
                    </div>
                    <div>{aff.banking_name || "—"}</div>
                    <div>{aff.account_number || "—"}</div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default AffiliateApplications;
